module.exports = __webpack_public_path__ + "img/afbeelding-evenement-4x.15f22143.png";